export default __webpack_public_path__ + "static/media/fluidity.2b22c8ea.svg";